import { EventTrackingParameters } from 'types/event-tracking-parameters'

/**
 * Tracks events by pushing data to GTM
 *
 * @param events
 * @param parameters
 */
export const trackEvent = (event: string, parameters?: EventTrackingParameters): void => {
  if ((window as any).dataLayer) {
    ;(window as any).dataLayer.push({ event, ...parameters })
  }
}

/**
 * Resets the data layer
 */
export const resetDataLayer = (): void => {
  if ((window as any).dataLayer) {
    ;(window as any).dataLayer.push(() => {
      ;(window as any).dataLayer.reset()
    })
  }
}
